import { render, staticRenderFns } from "./fingerfoodItem.vue?vue&type=template&id=c43d374a&scoped=true&"
import script from "./fingerfoodItem.vue?vue&type=script&lang=js&"
export * from "./fingerfoodItem.vue?vue&type=script&lang=js&"
import style0 from "./fingerfoodItem.vue?vue&type=style&index=0&id=c43d374a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c43d374a",
  null
  
)

export default component.exports